import styled from "styled-components";
import { colorPalette, typeScale } from "../../utils/theme";

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== "isClosing",
})<{ isClosing: boolean }>`
  background-color: ${colorPalette.white};
  border-radius: 8px;
  width: auto;
  z-index: 10000;
  padding-bottom: var(--safe-area-inset-bottom);

  /* Apply min-width only on larger screens */
  @media (min-width: 768px) {
    max-width: 700px;
  }

  /* Mobile-specific styles for bottom modal sheet */
  @media (max-width: 767.98px) {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    max-height: 80vh;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    animation: ${({ isClosing }) =>
      isClosing ? "slideDown 0.3s ease-out" : "slideUp 0.3s ease-out"};

    @keyframes slideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }

    @keyframes slideDown {
      from {
        transform: translateY(0);
      }
      to {
        transform: translateY(100%);
      }
    }
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: start;
  padding: 16px;
  border-bottom: 1px solid ${colorPalette.blue100};
`;

export const HeaderTitle = styled.h2`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingXSMain}
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXSMain}
`;

export const ModalBody = styled.div`
  text-align: start;
  overflow-y: auto;
  max-height: 70vh;

  /* Apply max-height only on larger screens */
  @media (min-width: 768px) {
    max-height: 600px;
  }
`;

export const ContentWrapper = styled.div`
  padding: 16px 24px;

  p {
    color: ${colorPalette.textDark};
    ${typeScale.bodyXXS};
  }
`;

export const SectionTitle = styled.h4`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingXS};
`;

export const SectionSubtitle = styled.h4`
  margin-bottom: 6px;
  color: ${colorPalette.primaryDark};
  ${typeScale.bodySMMain};
`;

export const TotalPercentage = styled.h4`
  margin: 0;
  color: ${colorPalette.primaryDark};
  ${typeScale.bodySM};
`;

export const VatInfo = styled.h4`
  margin: 0;
  text-align: end;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXXS};
`;

export const SectionBigTitle = styled.h4`
  margin-bottom: 6px;
  color: ${colorPalette.primaryDark};
  ${typeScale.headingXS};
`;

export const ItemRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  color: ${colorPalette.textMain};
  ${typeScale.bodyXS}
`;

export const ItemDescription = styled.h5`
  color: ${colorPalette.textMain};
  margin-top: 16px;
  margin-bottom: 8px;
  ${typeScale.bodySMMain};
`;

export const CostWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ItemCost = styled.span`
  color: ${colorPalette.primaryDark};
  ${typeScale.bodyXS}
`;

export const MinCostText = styled.span`
  color: ${colorPalette.textDark};
  ${typeScale.bodyXXS};
`;

export const PromotionBadge = styled.div`
  margin-top: 4px;
  background-color: ${colorPalette.successLight};
  padding: 4px;
  border-radius: 4px;
`;

export const PromotionText = styled.p`
  margin: 0;
  color: ${colorPalette.successMedium};
  ${typeScale.bodyXXS};
`;
